import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_ARCHIVED = "/admin/client/archived";

export async function Archive() {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.get(API_ARCHIVED, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function ArchiveUser(id) {
  if (!String(id ?? "").trim()) return null;
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    return await AxiosInstance.post("/admin/client/archived", null, {
      params: { id },
      headers: { Authorization: "Bearer " + token },
    });
  } catch (error) {
    console.error("error in archive request:", error);
    throw error;
  }
}

export async function DeleteArchivedUser(id) {
  if (!String(id ?? "").trim()) return null;

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.delete("/admin/client/archived", {
      params: { id },
      headers: { Authorization: "Bearer " + token },
    });
  } catch (error) {
    console.error("error in archived delete request:", error);
    throw error;
  }
}

export async function RestoreUser(id) {
  if (!String(id ?? "").trim()) return null;

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.post("/admin/client/restore", null, {
      params: { id },
      headers: { Authorization: "Bearer " + token },
    });
  } catch (error) {
    console.error("error in restore request:", error);
    throw error;
  }
}

const ArchiveService = {
  Archive,
  ArchiveUser,
  RestoreUser,
  DeleteArchivedUser,
};

export default ArchiveService;
